// Generated by CoffeeScript 2.4.1
(function() {
  var GET, Ops, POST, Weaver, WeaverObject, WeaverProject, cuid;

  cuid = require('cuid');

  Ops = require('./Operation');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  WeaverProject = (function() {
    class WeaverProject extends WeaverObject {
      constructor(name = 'unnamed', id = cuid()) {
        super(id, name);
      }

      static async load(id) {
        var list;
        list = (await GET("project", {id}));
        return WeaverProject.loadFromServerObject(list[0]);
      }

      static async list() {
        var i, len, list, p, results;
        list = (await GET("project"));
        results = [];
        for (i = 0, len = list.length; i < len; i++) {
          p = list[i];
          results.push(WeaverProject.loadFromServerObject(p));
        }
        return results;
      }

      static loadFromServerObject(projectObject) {
        var project;
        project = new Weaver.Project(projectObject.name, projectObject.id);
        project._stored = true;
        project.acl = projectObject.acl;
        project.apps = projectObject.apps;
        return project;
      }

      async save() {
        this.acl = (await POST("project.create", {
          id: this.id(),
          name: this.name()
        }));
        await new Promise((resolve) => {
          var checkReady;
          checkReady = async() => {
            var project;
            project = (await this.ready());
            if (!project.ready) {
              return setTimeout(checkReady, WeaverProject.READY_RETRY_TIMEOUT); // Check again after some time
            } else {
              return resolve();
            }
          };
          return checkReady();
        });
        this._stored = true;
        return this;
      }

      ready() {
        return GET("project.ready", {
          id: this.id()
        }, "$SYSTEM");
      }

      freeze() {
        return GET("project.freeze", {
          id: this.id()
        }, this.id());
      }

      unfreeze() {
        return GET("project.unfreeze", {
          id: this.id()
        }, this.id());
      }

      isFrozen() {
        return GET("project.isfrozen", {
          id: this.id()
        }, this.id());
      }

      addMetadata(bundleKey, key, data) {
        return POST("project.metadata.add", {
          id: this.id(),
          bundleKey,
          key,
          data
        }, this.id());
      }

      removeMetadata(bundleKey, key) {
        return POST("project.metadata.remove", {
          id: this.id(),
          bundleKey,
          key
        }, this.id());
      }

      getMetadata(bundleKey, key) {
        return GET("project.metadata.get", {
          id: this.id(),
          bundleKey,
          key
        }, this.id());
      }

      getAllNodes(attributes) {
        return POST('nodes', {attributes}, this.id());
      }

      getAllRelations() {
        return GET('relations', this.id());
      }

      async rename(name) {
        var renamed;
        renamed = (await POST("project.name", {
          name,
          id: this.id()
        }, this.id()));
        this._name = name;
        return renamed;
      }

      getSnapshot(json = true, zipped = false, stored = false) {
        return GET('snapshot', {json, zipped, stored}, this.id());
      }

      getSnapshotGraph(graphs = [], fromGraphs = [], toGraphs = [], json = true, zipped = false, stored = false) {
        return GET('snapshotGraph', {graphs, fromGraphs, toGraphs, json, zipped, stored}, this.id());
      }

      async clone(id, name, opts = {}) {
        var acl, args, project;
        args = {id, name};
        if (opts.data != null) {
          args.data = opts.data;
        }
        if (opts.files != null) {
          args.files = opts.files;
        }
        acl = (await POST("project.clone", args, this.id()));
        project = new Weaver.Project(name, id);
        project._stored = true;
        project.acl = acl;
        return project;
      }

      destroy() {
        return POST("project.delete", {
          id: this.id()
        }, this.id());
      }

      async wipe(opts) {
        await POST("v2.projects", {
          method: "POST",
          path: "/meta/functions/wipe"
        }, this.id());
        if (((opts != null ? opts.files : void 0) != null) && opts.files) {
          return (await POST('file.wipe', {
            id: this.id()
          }, this.id()));
        }
      }

      async getACL() {
        var aclObject;
        aclObject = (await GET("acl.read.byObject", {
          objectId: this.id()
        }));
        return Weaver.ACL.loadFromServerObject(aclObject);
      }

      listCommits(limit = 50, offset = 0) {
        return Weaver.getCoreManager().listCommits(this.projectId, limit, offset);
      }

      async listDomains() {
        return (await GET('project.listDomains', {
          id: this.id()
        }));
      }

      static async prune(params = {}) {
        return (await POST("v2.projects", {
          method: "POST",
          path: "/prune"
        }, params.target));
      }

    };

    WeaverProject.READY_RETRY_TIMEOUT = 200;

    return WeaverProject;

  }).call(this);

  module.exports = WeaverProject;

}).call(this);
